import type { FormikErrors, FormikValues } from "formik";
import { ApiError } from "@/lib/api";

/** Turn an API failure into a toast message and, for validation errors, per-field messages. */
export function getError<T extends FormikValues>(error: unknown): { message: string; fieldErrors?: FormikErrors<T> } {
  if (error instanceof ApiError) {
    const body = (error.body ?? {}) as { detail?: unknown; non_field_errors?: unknown } & Record<string, unknown>;

    if (error.status === 403) {
      return { message: typeof body.detail === "string" ? body.detail : "You don't have permission to perform this action." };
    }
    if (error.status >= 500) return { message: "Server error. Please try again later." };
    if (typeof body.detail === "string") return { message: body.detail };
    if (Array.isArray(body.non_field_errors) && typeof body.non_field_errors[0] === "string") {
      return { message: body.non_field_errors[0] };
    }
    if (error.status === 400 && error.body && typeof error.body === "object") {
      return { fieldErrors: error.body as FormikErrors<T>, message: "Please fix the errors." };
    }
    return { message: error.message || "Something went wrong." };
  }
  if (error instanceof Error && error.message) return { message: error.message };
  return { message: "Something went wrong." };
}
